/**
 * Authentication Service
 * Handles login, logout, and token management
 */

import { authAPI } from './api';
import { STORAGE_KEYS } from '../utils/constants';

export const authService = {
  /**
   * Login user and store token
   */
  login: async (username, password) => {
    const data = await authAPI.login(username, password);

    // Store token and user info
    localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, data.token);
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify({ username }));

    return data;
  },

  /**
   * Logout user and clear storage
   */
  logout: () => {
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
  },

  /**
   * Check if user is authenticated
   */
  isAuthenticated: () => {
    return !!localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  },

  /**
   * Get current user info
   */
  getCurrentUser: () => {
    const userJson = localStorage.getItem(STORAGE_KEYS.USER);
    return userJson ? JSON.parse(userJson) : null;
  },

  /**
   * Get auth token
   */
  getToken: () => {
    return localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  }
};
